<template>
  <div class="content">
    <div class="page-inner">
      <div class="page-header mb-0"  v-if="!fromMetadataPage">
        <router-link to="/distributions">
          <i class="fa fa-chevron-left mr-1"></i>
          {{ $t('my_releases') }}
        </router-link>
      </div>
      <div class="text-right" v-else>
        <button type="button" class="btn btn-sm gray" @click="revertMetadata()" v-if="fromMetadataPage" :disabled="!enableMetadata || loadingMetadata">
          <i class="fas fa-redo-alt"></i> {{ $t('revert_changes') }}
          <span v-if="loadingMetadata">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
        </button>
        <button type="button" class="btn btn-sm btn-primary" @click="changeMetadata()" v-if="fromMetadataPage" :disabled="!Object.values(metadataChangeClass).filter(elem => elem).length || loadingMetadata">
          <i class="fas fa-save"></i> {{ $t('save_changes') }}
          <span v-if="loadingMetadata">
            <i class="fa fa-spinner fa-spin"></i>
          </span>
        </button>
      </div>
      <DistributionProgress :distribution="distribution" v-if="!fromMetadataPage"></DistributionProgress>
      <div class="text-center p-3 mb-2">
        <a href="/tools" target="_blank" class="btn btn-link">
          {{ $t('try_new_cover_editor') }} <i class="fas fa-external-link-alt ml-2"></i>
        </a>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div :class="{ 'card': !fromMetadataPage }">
            <div class="card-header" v-if="!fromMetadataPage">
              <div class="card-title" v-if="distribution._id">{{ distribution.title }}</div>
              <div class="card-category">{{ $t('create_cover_description') }}</div>
            </div>
            <form @submit.prevent="!fromMetadataPage ? saveDistribution() : (() => {})()" id="distribution-cover-form">
              <div class="card-body" v-if="showUploadedImage">
                <div class="form-group form-show-validation row">
                  <label
                    for="first-name"
                    class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right"
                  >Current Cover</label>
                  <div class="col-lg-4 col-md-9 col-sm-8">
                    <img
                      :src="distribution.cover_image_small || distribution.cover_image"
                      alt
                      width="100%"
                    />
                    <button
                      button="button"
                      class="mt-2 btn"
                      @click="changeImage()"
                    >{{ $t('change_image') }}</button>
                  </div>
                </div>
              </div>

              <div class="card-body cover-editor-container" v-if="!showUploadedImage">
                <div class="form-group form-show-validation row">
                  <label
                    for="first-name"
                    class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right"
                  >{{ $t('design_type') }}</label>
                  <div class="col-lg-5 col-md-9 col-sm-8">
                    <div class="input-group text-center">
                      <ul class="nav nav-pills nav-primary w-100">
                        <li class="nav-item w-50">
                          <a
                            :class="{ active: designType === 'custom' }"
                            class="nav-link my-0 text-elipsis"
                            href="javascript:void(0)"
                            @click="switchToUpload()"
                          ><i class="fas fa-file-upload mr-1"></i> {{ $t('upload_file') }}</a>
                        </li>
                        <li class="nav-item w-50">
                          <a
                            :class="{ active: designType === 'editor' }"
                            class="nav-link my-0 text-capitalize"
                            href="javascript:void(0)"
                            @click="designType = 'editor'"
                          ><i class="fas fa-edit mr-1"></i> {{ $t('editor') }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div v-if="designType === 'editor'" class="editor">
                  <div class="form-group row">
                    <label class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">.</label>
                    <div class="col-lg-5 col-md-9 col-sm-8">
                      <div class="alert alert-primary" ref="upgradeAlert" v-if="!isPro && user.published && !fromMetadataPage">
                        <div>
                          {{ $t('upgrade_for_cover') }}<br/>
                          <ul class="mt-1">
                            <li>{{ $t('professional_template_images') }}</li>
                            <li>{{ $t('more_fonts_available') }}</li>
                            <li>{{ $t('multiple_projects_details') }}</li>
                          </ul>
                        </div>
                        <div class="mt-2">
                          <button type="button" @click="removeUpgradeAlert()" class="btn btn-default btn-sm mr-1 mb-1">{{ $t('maybe_later') }}</button>
                          <router-link to="/upgrade?from=extra_covers" tag="button" class="btn btn-gradient btn-sm mb-1">
                            {{ $t('upgrade_now') }} <i class="fa fa-rocket ml-1"></i>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-show-validation row">
                    <label
                      for="first-name"
                      class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right"
                    >{{ $t('text_align_editor') }}</label>
                    <div class="col-lg-5 col-md-9 col-sm-8">
                      <div class="input-group text-center">
                        <ul class="nav nav-pills nav-primary w-100">
                          <li class="nav-item w-50">
                            <a
                              :class="{ active: textAlign === 'left' }"
                              class="nav-link my-0"
                              href="javascript:void(0)"
                              @click="textAlign = 'left'"
                            ><i class="fas fa-align-left mr-1"></i> {{ $t('text_align_left') }}</a>
                          </li>
                          <li class="nav-item w-50">
                            <a
                              :class="{ active: textAlign === 'center' }"
                              class="nav-link my-0"
                              href="javascript:void(0)"
                              @click="textAlign = 'center'"
                            ><i class="fas fa-align-center mr-1"></i> {{ $t('text_align_center') }}</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-show-validation row">
                    <label
                      for="first-name"
                      class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right"
                    >{{ $t('indiefy_editor_font') }}</label>
                    <div class="col-lg-5 col-md-9 col-sm-8">
                      <div class="select2-input">
                        <Select2 v-model="font" :options="fonts"></Select2>
                      </div>
                    </div>
                  </div>
                  <div class="form-group form-show-validation row">
                    <label
                      for="first-name"
                      class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right"
                    >{{ $t('indiefy_editor_title_size') }}</label>
                    <div class="col-lg-5 col-md-9 col-sm-8">
                      <input
                        type="range"
                        class="form-control"
                        min="180"
                        max="400"
                        v-model="titleSize"
                      />
                    </div>
                  </div>
                  <div class="form-group form-show-validation row">
                    <label
                      for="first-name"
                      class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right"
                    >{{ $t('indiefy_editor_artist_size') }}</label>
                    <div class="col-lg-5 col-md-9 col-sm-8">
                      <input
                        type="range"
                        class="form-control"
                        min="120"
                        max="300"
                        v-model="artistSize"
                      />
                    </div>
                  </div>
                  <div class="form-group form-show-validation row">
                    <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right"></label>
                    <div v-if="distribution._id" class="col-lg-5 col-md-9 col-sm-8">
                      <CoverEditor
                        :titleSize="titleSize"
                        :artistSize="artistSize"
                        :font="font"
                        :textAlign="textAlign"
                        :distribution="distribution"
                      ></CoverEditor>
                    </div>
                  </div>
                </div>
                <div v-if="designType === 'custom'" class="custom">
                  <div class="form-group form-show-validation row">
                    <label for="first-name" class="col-lg-3 col-md-3 col-sm-4 mt-sm-2 text-right">
                      {{ $t('upload_file') }}
                      <span class="required-label">*</span>
                    </label>
                    <div class="col-lg-4 col-md-9 col-sm-8">
                      <croppa
                        :width="1400"
                        :height="1400"
                        :prevent-white-space="true"
                        v-model="myCroppa">
                      </croppa>
                      <div class="mt-sm">
                        <button class="btn btn-default btn-sm" type="button" @click="zoomOut()" :disabled="!hasFile">
                          <i class="fa fa-search-minus"></i>
                        </button>
                        <button class="btn btn-default btn-sm" type="button" @click="zoomIn()" :disabled="!hasFile">
                          <i class="fa fa-search-plus"></i>
                        </button>
                      </div>
                      <!-- <input ref="imageFile" type="file" accept=".jpg, .jpeg" id="imageFile" /> -->
                      <div class="small mt-3">
                        <i class="fas fa-exclamation-triangle text-warning mr-1"></i> {{ $t('cover_size_requirement') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-action" v-if="!fromMetadataPage">
                <div class="row">
                  <div class="col-md-12 text-right">
                    <router-link
                      tag="button"
                      :to="`/distributions/${distribution._id}/songs`"
                      class="btn btn-border no-border"
                      :disabled="uploading"
                    >
                      <i class="fa fa-chevron-left mr-1"></i>
                      {{ $t('back') }}
                    </router-link>
                    <button
                      class="btn btn-gradient ml-1"
                      type="button"
                      @click="nextPage()"
                      :disabled="uploading"
                    >
                      <span v-if="!uploading">
                        {{ $t('continue') }}
                        <i class="fa fa-chevron-right ml-1"></i>
                      </span>
                      <span v-if="uploading">
                        <i class="fa fa-spinner fa-spin"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- <div v-if="!user.subscription" class="text-center mb-3 mt-3">
        <ins class="adsbygoogle"
            style="display:block"
            data-ad-client="ca-pub-8326584585992829"
            data-ad-slot="3934111543"
            data-ad-format="auto"
            data-full-width-responsive="true"></ins>
      </div> -->
    </div>

    <UpgradeModal></UpgradeModal>
  </div>
</template>
<script>
import Vue from 'vue'
import Distributions from '../services/distributions'
import CoverEditor from '../components/CoverEditor'
import Select2 from './utils/Select2'
import rasterizeHTML from 'rasterizehtml'
import Upload from '../services/upload'
import _ from 'underscore'
import productLanguages from '../data/product-languages'
import performanceLanguages from '../data/performance-languages'
import DistributionProgress from './utils/DistributionProgress'
import Configuration from '../services/configuration'
import Public from '../services/public'
import UpgradeModal from './utils/UpgradeModal'

export default {
  name: 'DistributionCover',
  props: ['fromMetadataPage'],
  data: function () {
    return {
      name: 'DistributionCover',
      user: {},
      myCroppa: null,
      isPro: true,
      uploading: false,
      saving: false,
      showUploadedImage: false,
      titleSize: 180,
      artistSize: 120,
      lang: '',
      font: 'Source Sans Pro',
      textAlign: 'left',
      designType: 'editor',
      productLanguages: _.map(productLanguages, lang => {
        return { id: lang.value, text: lang.name }
      }),
      performanceLanguages: _.map(performanceLanguages, item => {
        return { id: item.value, text: item.name }
      }),
      distribution: {
        title: '',
        cover_image: '',
        cover_image_small: '',
        cover_image_code: 0,
        cover_image_font: '',
        cover_image_title: 180,
        cover_image_artist: 120,
        cover_image_alignment: '',
        artist: {
          name: ''
        },
        custom_label: null
      },
      fonts: [
        'Source Sans Pro',
        'Barriecito',
        'Russo One',
        'Lobster',
        'Pacifico',
        'Righteous',
        'Crete Round',
        'Satisfy',
        'Patua One',
        'Permanent Marker',
        'Luckiest Guy',
        'Shadows Into Light',
        'Cinzel',
        'Rajdhani',
        'Kaushan Script',
        'Merienda One'
      ],
      artist: [],
      replacedImage: false,
      reopeningOptions: [],
      metadata_request_data: {},
      metadataChangeClass: {
        file: false
      },
      enableMetadata: false,
      loadingMetadata: false,
      locationSettings: {}
    }
  },
  methods: {
    switchToUpload: function () {
      this.designType = 'custom'
    },
    zoomIn: function () {
      this.myCroppa.zoomIn()
    },
    zoomOut: function () {
      this.myCroppa.zoomOut()
    },
    removeUpgradeAlert: function () {
      window.$(this.$refs.upgradeAlert).remove()
    },
    changeImage: function () {
      if (!this.fromMetadataPage) {
        window.swal({
          title: this.$t('are_you_sure'),
          text: this.$t('cover_edit_warning'),
          buttons: {
            cancel: {
              visible: true,
              text: this.$t('cancel'),
              className: 'btn btn-default btn-border no-border'
            },
            confirm: {
              text: this.$t('ok'),
              className: 'btn btn-primary'
            }
          }
        }).then(confirm => {
          if (!confirm) {
            return
          }

          this.removeImage()
        })
      } else {
        window.swal({
          title: this.$t('are_you_sure'),
          buttons: {
            cancel: {
              visible: true,
              text: this.$t('cancel'),
              className: 'btn btn-default btn-border no-border'
            },
            confirm: {
              text: this.$t('ok'),
              className: 'btn btn-primary'
            }
          }
        }).then(confirm => {
          if (!confirm) {
            return
          }

          this.showUploadedImage = false
          this.metadataChangeClass['file'] = true
          this.$forceUpdate()
        })
      }
    },
    removeImage: function () {
      this.showUploadedImage = false

      Upload.removeImage(
        this.distribution.cover_image.split('/').pop(),
        'distro-covers'
      ).then(response => {})

      if (this.distribution.cover_image_small) {
        Upload.removeImage(
          this.distribution.cover_image_small.split('/').pop(),
          'distro-covers'
        ).then(response => {})
      }

      this.replacedImage = true
      this.distribution.cover_image = ''
      this.distribution.cover_image_small = ''
      this.saveDistribution()
    },
    checkImageSize: function (file, _callback) {
      let _URL = window.URL || window.webkitURL || window.mozURL || window.msURL
      let img

      if (file) {
        img = new Image()
        img.onload = function () {
          if (this.width >= 1400 && this.width <= 3000) {
            if (this.width === this.height) {
              _callback(true)
            } else {
              _callback(false)
            }
          } else {
            _callback(false)
          }
        }
        img.src = _URL.createObjectURL(file)
      } else {
        _callback(false)
      }
    },
    nextPage: function () {
      this.uploading = true

      if (this.distribution.cover_image) {
        this.saveDistribution(() => {
          this.uploading = false

          this.$notify({ message: this.$t('distribution_updated') }, 'success', 'fa fa-check')
          if (this.distribution.reopen_in_progress) {
            this.$router.push(`/distributions/${this.distribution._id}/review`)
          } else {
            this.$router.push(`/distributions/${this.distribution._id}/stores`)
          }
        })
      } else {
        // File Upload
        if (this.designType === 'custom') {
          if (!this.hasFile) {
            this.uploading = false
            this.$notify({ message: this.$t('please_select_image') }, 'warning', 'fa fa-exclamation')
            return
          }

          this.myCroppa.generateBlob(blob => {
            Upload.uploadImage(blob, 'distro-covers').then(response => {
              this.distribution.cover_image = response.data.full
              this.distribution.cover_image_small = response.data.small

              if (!this.distribution.cover_image) {
                this.uploading = false
                return this.$notify({ message: this.$t('cover_image_not_found') }, 'warning', 'fa fa-exclamation')
              }

              this.saveDistribution(() => {
                this.uploading = false

                if (this.distribution.reopen_in_progress) {
                  this.$router.push(`/distributions/${this.distribution._id}/review`)
                } else {
                  this.$router.push(`/distributions/${this.distribution._id}/stores`)
                }
              })
            })
          })
        } else {
          this.exportCanvas().then(() => {
            if (!this.distribution.cover_image) {
              this.uploading = false
              return this.$notify({ message: this.$t('cover_image_not_found') }, 'warning', 'fa fa-exclamation')
            }
            this.saveDistribution(() => {
              this.uploading = false

              if (!this.fromMetadataPage) {
                this.$router.push(`/distributions/${this.distribution._id}/stores`)
                this.$notify({ message: this.$t('distribution_updated') }, 'success', 'fa fa-check')
              } else {

              }
            })
          })
        }
      }
    },
    exportCanvas: function () {
      return new Promise(resolve => {
        let html = window.$('#cover-editor').html()
        let canvas = window.$('#cover-canvas')[0]

        html = html.replaceAll('CSS_STYLE_HERE',
          '<link class="something" rel="stylesheet" href="/static/css/bootstrap.min.css" defer>' +
          '<link class="something" rel="stylesheet" href="/static/css/fonts.min.css" defer>' +
          '<link class="something" href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700&display=swap" rel="stylesheet">'
        )

        rasterizeHTML.drawHTML(html, canvas).then(
          () => {
            canvas.toBlob(blob => {
              let file
              // eslint-disable-next-line
              if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
                file = new Blob([blob], { type: 'image/jpeg' })
                file.lastModifiedDate = new Date()
              } else {
                file = new File([blob], 'cover.jpeg', { type: 'image/jpeg' })
              }

              Upload.uploadImage(blob, 'distro-covers').then(response => {
                this.distribution.cover_image = response.data.full
                this.distribution.cover_image_small = response.data.small

                if (this.fromMetadataPage) {
                  this.distribution.metadata_request_data.new.cover_image = this.distribution.cover_image
                  this.distribution.metadata_request_data.new.cover_image_small = this.distribution.cover_image_small
                }

                resolve()
              })
            }, 'image/jpeg')
          },
          () => {}
        )
      })
    },
    saveDistribution: function (callback) {
      if (!this.distribution.steps) {
        this.distribution.steps = {}
      }

      this.distribution.steps.step_cover = { validate: true }
      this.distribution.fromPage = 'cover'

      return Distributions.save(this.distribution)
        .then(response => {
          if (typeof callback === 'function') {
            callback()
          }
        })
        .catch(err => {
          let error = err.response.data.name

          if (error === 'release_date_invalid') {
            this.$notify(
              { message: this.$t('release_date_invalid') },
              'danger',
              'fa-exclamation'
            )
          }

          if (error === 'already_exists') {
            this.$notify(
              { message: this.$t('distribution_name_repeated') },
              'danger',
              'fa-exclamation'
            )
          }

          if (error === 'distro_already_reviewed') {
            if (this.$route.params.id) {
              this.$router.push(`/distributions/${this.$route.params.id}/details`)
            } else {
              this.$router.push(`/distributions`)
            }
          }
        })
    },
    hasReopeningReason: function () {
      return (this.distribution.status === 0 && this.reopeningOptions.includes(this.distribution.reopening_reason))
    },
    changeMetadata: function () {
      if (this.fromMetadataPage) {
        window.swal({
          title: this.$t('are_you_sure'),
          buttons: {
            cancel: {
              visible: true,
              text: this.$t('cancel'),
              className: 'btn btn-default btn-border no-border'
            },
            confirm: {
              text: this.$t('ok'),
              className: 'btn btn-primary'
            }
          }
        }).then(confirm => {
          if (!confirm) {
            return
          }
          this.loadingMetadata = true
          new Promise(resolve => {
            if (this.designType === 'custom') {
              if (!this.hasFile) {
                this.uploading = false
                this.loadingMetadata = false
                this.$notify({ message: this.$t('please_select_image') }, 'warning', 'fa fa-exclamation')
                return
              }
              this.myCroppa.generateBlob(blob => {
                resolve(blob)
              })
            } else {
              let html = window.$('#cover-editor').html()
              let canvas = window.$('#cover-canvas')[0]
              let file

              rasterizeHTML.drawHTML(html, canvas).then(() => {
                canvas.toBlob(blob => {
                  // eslint-disable-next-line
                  if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
                    file = new Blob([blob], { type: 'image/jpeg' })
                    file.lastModifiedDate = new Date()
                  } else {
                    file = new File([blob], 'cover.jpeg', { type: 'image/jpeg' })
                  }
                  resolve(blob)
                }, 'image/jpeg')
              }, () => {

              })
            }
          }).then((blob) => {
            Upload.uploadImage(blob, 'distro-covers').then(response => {
              if (!response.data.full) {
                this.uploading = false
                this.loadingMetadata = false
                return this.$notify({ message: this.$t('cover_image_not_found') }, 'warning', 'fa fa-exclamation')
              }
              this.distribution.cover_image = response.data.full
              this.distribution.cover_image_small = response.data.small

              let notifyData = {origin: this.name}
              this.metadata_request_data[this.name].cover_image = response.data.full
              this.metadata_request_data[this.name].cover_image_small = response.data.small

              notifyData.data = this.metadata_request_data[this.name]

              this.$eventBus.$emit('notifyMetadataChanges', notifyData)

              Distributions.saveMetadaRequest(this.distribution._id, this.name, this.metadata_request_data[this.name]).then(response => {
                this.$eventBus.$emit('notifyMetadataModified', {origin: this.name, data: this.metadata_request_data[this.name]})
                this.$notify({ message: this.$t('changes_saved') }, 'success', 'fa-check')
                this.showUploadedImage = true
                this.enableMetadata = !!_.find(this.metadata_request_data[this.name], elem => elem)
                this.loadingMetadata = false
                this.$forceUpdate()
              })
            })
          })
        })
      }
    },
    revertMetadata: function () {
      if (this.fromMetadataPage) {
        window.swal({
          title: this.$t('are_you_sure'),
          text: this.$t('cover_edit_warning'),
          buttons: {
            cancel: {
              visible: true,
              text: this.$t('cancel'),
              className: 'btn btn-default btn-border no-border'
            },
            confirm: {
              text: this.$t('ok'),
              className: 'btn btn-primary'
            }
          }
        }).then(confirm => {
          if (!confirm) {
            return
          }
          this.loadingMetadata = true

          let promise1 = new Promise(resolve => {
            Upload.removeImage(
              this.distribution.cover_image.split('/').pop(),
              'distro-covers'
            ).then(() => {
              resolve()
            })
          })

          let promise2 = new Promise(resolve => {
            if (this.distribution.cover_image_small) {
              Upload.removeImage(
                this.distribution.cover_image_small.split('/').pop(),
                'distro-covers'
              ).then(() => {
                resolve()
              })
            } else {
              resolve()
            }
          })

          Promise.all([promise1, promise2]).then(() => {
            Distributions.revertChangesMetadaRequest(this.distribution._id, this.name).then(response => {
              this.distribution.cover_image = JSON.parse(JSON.stringify(this.distributionOriginal)).cover_image
              this.distribution.cover_image_small = JSON.parse(JSON.stringify(this.distributionOriginal)).cover_image_small

              this.metadata_request_data[this.name] = {}
              this.enableMetadata = !!_.find(this.metadata_request_data[this.name], elem => elem)
              this.metadataChangeClass = {}

              this.$eventBus.$emit('notifyMetadataModified', {origin: this.name, data: this.metadata_request_data[this.name]})

              this.$notify({ message: this.$t('changes_saved') }, 'success', 'fa-check')
              this.loadingMetadata = false
              this.$forceUpdate()
            })
          })
        })
      }
    },
    getDistribution: function () {
      return Distributions.get(this.$route.params.id).then(response => {
        this.distribution = response.data

        if (this.fromMetadataPage) {
          this.distributionOriginal = JSON.parse(JSON.stringify(response.data))
          if (!this.distributionOriginal.metadata_request_data || !this.distributionOriginal.metadata_request_data[this.name]) {
            this.metadata_request_data[this.name] = {}
          } else {
            this.metadata_request_data[this.name] = this.distributionOriginal.metadata_request_data[this.name]
            _.each(this.metadata_request_data[this.name], (elem, key) => {
              this.distribution[key] = elem
              this.metadataChangeClass[key] = true
            })
          }
          this.enableMetadata = !!_.find(this.metadata_request_data[this.name], elem => elem)
        }

        if (!this.fromMetadataPage) {
          if (this.distribution.status > 0) {
            if (this.$route.params.id) {
              return this.$router.push(`/distributions/${this.$route.params.id}/details`)
            } else {
              return this.$router.push(`/distributions`)
            }
          } else if (this.hasReopeningReason()) {
            if (!this.distribution.reopen_in_progress) {
              if (this.$route.params.id) {
                return this.$router.push(`/distributions/${this.$route.params.id}/reopening-details`)
              } else {
                return this.$router.push(`/distributions`)
              }
            }
          }
        }

        let missingFile = _.find(this.distribution.songs, song => !song.file_url)

        if (!this.distribution.songs || missingFile) {
          this.$notify({ message: this.$t('invalid_audio_detected') }, 'warning', 'fa-exclamation')
          return this.$router.push(`/distributions/${this.$route.params.id}/songs`)
        }

        if (this.distribution.cover_image_alignment) {
          this.textAlign = this.distribution.cover_image_alignment
        }

        if (this.distribution.cover_image_font) {
          this.font = this.distribution.cover_image_font
        }

        if (this.distribution.cover_image_title) {
          this.titleSize = parseInt(this.distribution.cover_image_title)
        }

        if (this.distribution.cover_image_artist) {
          this.artistSize = parseInt(this.distribution.cover_image_artist)
        }

        if (this.distribution.cover_image) {
          this.showUploadedImage = true
        }

        if (this.fromMetadataPage) {
          this.artist = this.distribution.artist
        }

        this.$eventBus.$on('updateCoverCode', code => {
          Vue.set(this.distribution, 'cover_image_code', code)
          this.$forceUpdate()
        })
      })
    }
  },
  watch: {
    textAlign: function (value) {
      this.distribution.cover_image_alignment = value
    },
    titleSize: function (value) {
      this.distribution.cover_image_title = value
    },
    artistSize: function (value) {
      this.distribution.cover_image_artist = value
    },
    font: function (value) {
      this.distribution.cover_image_font = value
    }
  },
  created: function () {
    this.user = this.$user
    this.lang = this.$i18n.locale

    Configuration.get({fields: ['reopen_reasons_fields']}).then(response => {
      this.reopeningOptions = _.map(response.data.reopen_reasons_fields, (elem, key) => key)
    })

    if (this.$i18n && this.$i18n.locale === 'zh') {
      this.fonts.push('Noto Sans SC')
      this.font = 'Noto Sans SC'
    } else if (this.$i18n && this.$i18n.locale === 'ar') {
      this.fonts.push('Lemonada')
      this.font = 'Lemonada'
    }

    if (!this.$user.subscription && this.user.published) {
      this.isPro = false
      this.fonts = [this.fonts[0]]
    } else {
      this.isPro = true
    }

    if (this.$route.params.id) {
      this.getDistribution().then(() => {
        this.$forceUpdate()
      })
    }

    this.$eventBus.$on('setTitleOnCover', (title) => {
      this.distribution.title = title
    })

    Public.getLocationSettings().then(responseSettings => {
      this.locationSettings = responseSettings.data

      if (this.locationSettings.hide_basic && !this.user.subscription) {
        return this.$router.push(`/upgrade?from=cover_limit_location`)
      }
    })
  },
  computed: {
    hasFile: function () {
      return this.myCroppa && this.myCroppa.getChosenFile && this.myCroppa.getChosenFile()
    }
  },
  mounted: function () {
    // if (!this.user.subscription) {
    //   setTimeout(() => {
    //     (window.adsbygoogle = window.adsbygoogle || []).push({})
    //   }, 1200)
    // }

    window.scrollTo(0, 0)
  },
  components: {
    Select2,
    CoverEditor,
    DistributionProgress,
    UpgradeModal
  }
}
</script>
<style lang="scss" scoped>
#distribution-image {
  width: 200px;
  height: 200px;
  border-radius: 3px;
}

.croppa-container {
  transform: scale(0.2);
  transform-origin: 0 0;
}

.text-elipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.cover-editor-container {
  .custom {
    max-height: 430px;
  }
  .editor {
    max-height: 1010px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DistributionCover.vue